"use client";

import { Typography } from "@/components/ui/typography";
import { memo } from "react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import Link from "next/link";

export type FaqLinkBlockProps = {
  title?: string;
  href?: string;
  label?: string;
} & React.ComponentProps<"div">;

const FaqLinkBlock = ({
  title = "Have more questions? Visit our FAQ page for more answers.",
  href = "/faq",
  label = "Explore FAQ",
  className,
}: FaqLinkBlockProps) => {
  return (
    <div className={cn("font-medium", className)}>
      <Typography
        variant="titleSm"
        className="text-semantic-text-primary lg:text-gray-800 text-center"
      >
        <p
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
      </Typography>
      <div className="mt-4 text-center flex items-center justify-center">
        <Button
          asChild
          variant="primary-outline"
          className="flex-auto min-w-0 sm:flex-initial py-3 px-6 h-[48px] w-full sm:w-auto"
        >
          <Link href={href} className="!text-base">
            {label}
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default memo(FaqLinkBlock);
